import { BASE_URL } from "../config";
import { axiosInstance } from "../providers/AxiosProvider";

export function generateCredentials(examinerId) {
  return axiosInstance.get(
    `${BASE_URL}/api/examiners/${examinerId}/credentials`
  );
}

export function deleteCredentials(examinerId) {
  return axiosInstance.delete(
    `${BASE_URL}/api/examiners/${examinerId}/credentials`
  );
}
